
import piProducerAdd from "./components/pi-add-report-file/pi-add-report-file.vue";
import piProducerDetails from "./components/pi-details-report-file/pi-details-report-file.vue";
import piProducerUpdata from "./components/pi-updata-report-file/pi-updata-report-file.vue";
import { Component, Vue } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import { getDeviceArchivePage, delDeviceArchive } from "@/api/api-basic";
import piSelectOper from "@/components/select-oper/select-oper.vue";
import piExport from "@/components/pi-export/pi-export.vue";
import i18n from "@/config/i18n";
@Component({
  components: {
    piSelectOper,
    "pi-add-producer": piProducerAdd,
    "pi-details-producer": piProducerDetails,
    "pi-updata-producer": piProducerUpdata,
    "pi-export": piExport
  }
})
export default class PiReportFile extends Vue {
  private privilegeVoObj: objAny = {};

  private formInline: objAny = {
    globalOrder: "",
    globalPageIndex: 1,
    globalPageSize: 10,
    globalSearch: "",
    oprPkId: "",
    minDeviceRatedPower: "",
    maxDeviceRatedPower: ""
  };
  private total = 0;
  private addShow = false;
  private loading = false;
  private time = "";
  private tableList: object[] = [{}];
  private tableColumns: object[] = [
    {
      title: i18n.t("reportFile.deviceArchivePkId"),
      key: "deviceArchivePkId",
      minWidth: 160
    },
    {
      title: i18n.t("reportFile.deviceTypeName"),
      key: "deviceTypeDesc",
      minWidth: 120
    },
    {
      title:
        i18n.t("reportFile.deviceModelName") +
        " / " +
        i18n.t("reportFile.deviceModelRatedPower") +
        " / " +
        i18n.t("reportFile.manufacturerName") +
        " / " +
        i18n.t("reportFile.deviceModelChargeStandardName"),
      key: "manufacturerName",
      slot: "more",
      minWidth: 360
    },
    {
      title: i18n.t("reportFile.archiveCode"),
      key: "archiveCode",
      minWidth: 120
    },
    {
      title: i18n.t("reportFile.feelerMechanismName"),
      key: "feelerMechanismName",
      minWidth: 110
    },
    {
      title: i18n.t("reportFile.archiveCreateDate"),
      key: "archiveCreateDate",
      minWidth: 160
    },
    {
      title: i18n.t("reportFile.attachmentRecordPkId"),
      key: "attachmentRecordPkId",
      minWidth: 120,
      slot: "typeNo"
    },
    // {
    //   title: "录入日期",
    //   key: "legalIdCard",
    //   minWidth: 160
    // },
    {
      title: i18n.t("operation"),
      slot: "action",
      minWidth: 180,
      align: "center"
    }
  ];
  private timeFn(val: string): void {
    if (val) {
      this.formInline.archiveCreateDate = val;
    } else {
      this.formInline.archiveCreateDate = "";
    }
  }

  public tableChange(val: number) {
    this.formInline.globalPageIndex = val;
    this.getTableList();
  }
  public tableSizeChange(val: number) {
    this.formInline.globalPageSize = val;
    this.getTableList();
  }

  async getTableList(): Promise<void> {
    if (
      this.formInline.minDeviceRatedPower &&
      this.formInline.maxDeviceRatedPower
    ) {
      if (this.formInline.minDeviceRatedPower < 0) {
        this.$Message.error(i18n.t("reportFile.minDeviceRatedPowerError"));
        return;
      } else if (this.formInline.maxDeviceRatedPower < 0) {
        this.$Message.error(i18n.t("reportFile.maxDeviceRatedPowerError"));
        return;
      } else if (
        this.formInline.minDeviceRatedPower >
        this.formInline.maxDeviceRatedPower
      ) {
        this.$Message.error(i18n.t("reportFile.minMaxDeviceRatedPowerError"));
        return;
      }
    }
    this.loading = true;
    const ret = await getDeviceArchivePage(this.formInline);
    if (ret.status === this.$config.apiStatus) {
      this.tableList = ret.data;
      this.total = ret.total;
    }
    this.loading = false;
  }
  public searchClick() {
    this.formInline.globalPageIndex = 1;
    this.getTableList();
  }
  public addClick() {
    const piProducerAdd: objAny = this.$refs["piProducerAdd"];
    piProducerAdd.open();
  }
  public editClick(item: objAny) {
    const piProducerUpdata: objAny = this.$refs["piProducerUpdata"];
    piProducerUpdata.open(item);
  }
  public detailsClick(item: objAny) {
    const piProducerDetails: objAny = this.$refs["piProducerDetails"];
    piProducerDetails.open(item);
  }

  async delItemClick(item: objAny): Promise<void> {
    const ret = await delDeviceArchive({
      deviceArchivePkId: item.deviceArchivePkId
    });
    if (ret.status === this.$config.apiStatus) {
      this.$Message.success(i18n.t("deleteSuccess"));
      this.getTableList();
    }
  }

  mounted() {
    this.getTableList();
    this.privilegeVoObj = this.$route.meta.privilegeVoObj;
  }
}
